import CaracteristicsSection from "./CaracteristicsSection.view";

export default CaracteristicsSection;
